import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import Loading from "../spinners/Loading";
import { useDispatch, useSelector } from "react-redux";
import { setDialog } from "../../features/dialog/dialogSlice";
import ErrorAlert from "../alerts/ErrorAlert";
import { useDeleteQMStructureMutation } from "../../features/fileManager/fileManagerApiSlice";
import { selectCurrentOffice } from "../../features/auth/authSlice";

function QMFolderStructureDeleteDialog({ handleClose }) {
  const dispatch = useDispatch();
  const currentOffice = useSelector(selectCurrentOffice);

  const [deleteQMFolder, { isLoading, isError }] =
    useDeleteQMStructureMutation();

  const handleDeleteQMFolderStructure = async () => {
    console.log("currentOffice :>> ", currentOffice);

    try {
      let result = await deleteQMFolder({ id: currentOffice }).unwrap();
      console.log("result :>> ", result);
      if (result?.status === "success") {
        dispatch(
          setDialog({
            title: "QM Struktur wurde erfolgreich gelöscht!",
            type: "SUCCESS",
            data: {
              successText: "QM Struktur wurde erfolgreich gelöscht!",
            },
          })
        );
      }
    } catch (error) {
      console.log("error :>> ", error);
    }
  };

  return (
    <div>
      <Dialog
        onClose={!isLoading ? () => handleClose() : null}
        open
        maxWidth="lg"
      >
        <DialogTitle>Praxis löschen</DialogTitle>
        <DialogContent>
          {isLoading && (
            <div style={{ minHeight: 300, minWidth: 300 }}>
              <Loading />
            </div>
          )}

          {!isLoading && (
            <div>
              <Typography variant="h3" id="success-dialog-description">
                Möchten Sie die QM Struktur wirklich löschen??
              </Typography>
              <table style={{ fontSize: "150%" }}>
                <tr>
                  <th>Praxis:</th>
                  {/* <th>{officeData.officeName}</th> */}
                </tr>
              </table>
            </div>
          )}
          {isError && (
            <ErrorAlert errorMessage="Fehler beim Löschen der Praxis" />
          )}
        </DialogContent>
        <DialogActions>
          <Button disabled={isLoading} onClick={handleClose} color="primary">
            Beenden
          </Button>
          <Button
            disabled={isLoading}
            onClick={handleDeleteQMFolderStructure}
            color="error"
            variant="contained"
            autoFocus
          >
            LÖSCHEN
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default QMFolderStructureDeleteDialog;

QMFolderStructureDeleteDialog.propTypes = {
  officeData: PropTypes.object,
  dialogType: PropTypes.string,
};
